/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SoldInputs */

const cs_enum_sold = /** @type {(inputs: Enum_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodáno`)
};

const en_enum_sold = /** @type {(inputs: Enum_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Enum_SoldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sold = /** @type {((inputs?: Enum_SoldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SoldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sold(inputs)
	return cs_enum_sold(inputs)
});